import { useContext } from "react";

import { Outlet } from "react-router-dom";
import { useLocalization } from "@fluent/react";
import { modules, ComposeProviders } from "byzantine";
import { wireTypeSelectorForm } from "byzantine/src/dbbl/businessLogic/modules/internationalWires/WireTransferContainer.form";
import {
  InternationalWireFormProvider,
  CurrencyProvider,
} from "byzantine/src/dbbl/businessLogic/modules/internationalWires";

import AccountContext from "../../../../components/contexts/AccountContext";

/**
 * Layout route that keeps wire form providers mounted across
 * /transfer/wires/* and /templates/wire/* navigation, so form
 * state is preserved when the user temporarily visits template
 * management mid-flow.
 */
const WireFlowProviders = [
  modules.wireTemplates.bootstrap.Provider,
  modules.wireTemplates.methodSelectorForm.Provider,
  modules.wireTemplates.sendViaTemplateForm.Provider,
  wireTypeSelectorForm.Provider,
  modules.internationalWires.bootstrap.Provider,
  CurrencyProvider,
];

const WireFlowLayout = () => {
  const { accounts } = useContext(AccountContext);
  const { l10n } = useLocalization();

  return (
    <ComposeProviders components={WireFlowProviders}>
      <InternationalWireFormProvider accounts={accounts} l10n={l10n}>
        <Outlet />
      </InternationalWireFormProvider>
    </ComposeProviders>
  );
};

export default WireFlowLayout;
